import { Input } from "antd";
import { useEffect, useState } from "react";
import { Col, Modal, Row, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";

function ModalCheque({data}) {

    const { show, handleClose, handleAgregarDatoBancarios } = data;
    const pagos = useSelector((state) => state.formapagoredux.pagos ) || [];
    const [datoCheque, setDatoCheque] = useState({ num_cheque: "", tipo: "CQ" });
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleChange = (event) => {
        const value = event.target.value.replace(/[^0-9.]/g, "");
        setDatoCheque({ ...datoCheque, [event.target.name]: value });
    };

    const guardarDatosBancarios = async() => {
        setLoading(true);
        handleAgregarDatoBancarios(datoCheque);
        setDatoCheque({ num_cheque: "" });
        setLoading(false);
    }

    useEffect(() => {
        if (show && pagos.length > 0) {
            const pagoCQ = pagos.find(pago => pago.datosBancario.tipo === "CQ");

            if (pagoCQ) {
                setIsEditing(true);
                setDatoCheque({ 
                    num_cheque: pagoCQ.datosBancario.num_cheque || "",
                    tipo: "CQ",
                });
            }
        }
    }, [show, pagos]);

    return(
        <Modal show={show} backdrop="static" onHide={handleClose} keyboard={false} size="md">
            <Modal.Header closeButton>
                <Modal.Title>{ isEditing ? 'Actualizar' : 'Agregar'} Datos Cheque</Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <Row>
                    <Col>
                        <div className="d-flex align-items-center pb-2">
                            <div className="form-group col-md-12">
                                <label htmlFor="num_cheque">
                                    No. de Cheque
                                </label>
                                <Input
                                    type="text"
                                    className="me-2 flex-grow-1"
                                    id="num_cheque"
                                    value={datoCheque.num_cheque}
                                    name="num_cheque"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </Col>

                </Row>

            </Modal.Body>

            <Modal.Footer>
                <div className="mb-3 text-end">
                    <button className="btn btn-light m-1" disabled={loading} onClick={handleClose}>Cancelar</button>
                    <button className="btn btn-primary m-1" onClick={guardarDatosBancarios} disabled={loading || !datoCheque.num_cheque}>
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Por favor espere...
                            </>
                        ) :  isEditing ? 'Actualizar' : 'Agregar' }
                    </button>
                </div>
            </Modal.Footer>            

        </Modal>
    )
}

export default ModalCheque;